import endpoints, { axios } from "../config/api";

function getTaskByTaskId(taskId: number) {
  return axios.get(endpoints.task.getByTaskId(taskId));
}

export default getTaskByTaskId;
